import { type MouseEvent, type ReactNode } from "react";
import { type ArrowLinkProps, BackLink, LinkType } from "../../../common/components/Link";
import { useDispatch, useSelector } from "react-redux";
import { navigationGoBack } from "../../../Header/redux/actions";
import classNames from "classnames";
import { IconSize } from "../../../common/components/icon/IconSize";
import { selectGoBackTitle } from "../../../Header/redux/navigationSelectors";
import { useTranslation } from "react-i18next";

interface Props extends Omit<ArrowLinkProps, "children"> {
  visibleColAmount: number;
}

export const GoBackLink = ({ className, visibleColAmount, ...rest }: Props) => {
  const dispatch = useDispatch();
  const goBack = (e: MouseEvent) => {
    e.preventDefault();
    dispatch(navigationGoBack());
  };

  const goBackLabel = useGoBackLabel(visibleColAmount);

  return (
    <BackLink
      variant={LinkType.PRIMARY}
      className={classNames("title-medium", className)}
      onClick={goBack}
      iconSize={IconSize.FONT_24}
      {...rest}
    >
      {goBackLabel}
    </BackLink>
  );
};

const useGoBackLabel = (visibleColumnAmount: number): ReactNode | string => {
  const { t } = useTranslation();
  const goBackLabel = useSelector(selectGoBackTitle(visibleColumnAmount));

  if (!goBackLabel) {
    return t("navigation.home");
  }

  return t(goBackLabel);
};
